import React, { useEffect, useState } from "react";
import { Box, Container } from "@mui/material";
import { useFetchDetail, usePutDetail } from "@hooks/useFetchDetail";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import HeroCst from "@components/HeroCst";
import AddEditFormCst from "@components/AddEditFormCst";
import BackgroundImageCst from "@components/BackgroundImageCst";
import Breadcrumb from "@components/Breadcrumb";
import { useTranslation } from "react-i18next";
import { ServicesURL } from "@utils/utilsApi";
import { PagesID } from "@utils/utilsConfigurations";
import ModalConfirmsCst from "@components/ModalConfirmsCst";
import { StatusEnum } from "@components/ModalConfirmsCst/types";
import AnimationFadeIn from "@components/AnimationFadeIn";

const EditGroups: React.FC = () => {
  const { t } = useTranslation(["groups-page"]);
  const { idGroup, id } = useParams();
  const [openToast, setOpenToast] = useState<{
    s: StatusEnum;
    message: string;
    description?: string;
  }>();
  const { columns, dataDetail, mutate } = useFetchDetail(
    ServicesURL.staticGroups + "/static",
    idGroup || "",
    PagesID["corporate.groups"]
  );
  const { trigger: triggerPutGroups, setId: setPutGroupId } = usePutDetail(
    ServicesURL.staticGroups
  );

  useEffect(() => {
    idGroup && setPutGroupId(idGroup);
  }, [idGroup, setPutGroupId]);

  const navigate = useNavigate();

  const onSubmit = async (inputForm: any) => {
    let objToSend: any = {
      name: inputForm["name"] || "",
      description: inputForm["description"] || "",
    };
    try {
      await await triggerPutGroups(objToSend);
      setOpenToast({ s: StatusEnum.OK, message: "" });
    } catch (error) {
      console.error(error);
      setOpenToast(undefined);
    }
    mutate && mutate(inputForm);
  };

  return (
    <AnimationFadeIn>
      <BackgroundImageCst
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-corp-groups.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst
          title={t("edit.hero-title")}
          description={t("edit.hero-description")}
        />
        {columns && (
          <Box
            sx={{
              mt: "25px",
            }}
          >
            <AddEditFormCst
              row={dataDetail}
              columns={columns}
              onSubmit={onSubmit}
              backButton={() => {
                navigate(`/corporate/${id}/detail/groups`);
              }}
            />
          </Box>
        )}
        <ModalConfirmsCst
          open={!!openToast}
          title={t("outcome-item", { ns: "modal" })}
          description={t("outcome-item", { ns: "modal" })}
          onCallBackClosed={() => {
            navigate(`/corporate/${id}/detail/groups`);
          }}
          onActionConfirmed={() => {
            navigate(`/corporate/${id}/detail/groups`);
          }}
          status={openToast}
        />
      </Container>
    </AnimationFadeIn>
  );
};

export default EditGroups;
